import type { MyProfile, UpdateMyProfileRequest } from '../api/types';

export type ProfileDetailKey = keyof UpdateMyProfileRequest;

export type ProfileDetails = Record<ProfileDetailKey, string>;

export const PROFILE_DETAIL_KEYS: ProfileDetailKey[] = [
  'firstName',
  'lastName',
  'phone',
  'personalPhone',
  'personalEmail',
  'address',
];

export function profileDetails(profile: MyProfile | null): ProfileDetails {
  return {
    firstName: profile?.firstName ?? '',
    lastName: profile?.lastName ?? '',
    phone: profile?.phone ?? '',
    personalPhone: profile?.personalPhone ?? '',
    personalEmail: profile?.personalEmail ?? '',
    address: profile?.address ?? '',
  };
}

export function detailsChanged(saved: ProfileDetails, edited: ProfileDetails): boolean {
  return PROFILE_DETAIL_KEYS.some((key) => saved[key].trim() !== edited[key].trim());
}

export function detailsRequest(edited: ProfileDetails): UpdateMyProfileRequest {
  return {
    firstName: edited.firstName.trim(),
    lastName: edited.lastName.trim(),
    phone: edited.phone.trim(),
    personalPhone: edited.personalPhone.trim(),
    personalEmail: edited.personalEmail.trim(),
    address: edited.address.trim(),
  };
}

export function displayName(profile: MyProfile): string {
  return [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim() || profile.username;
}
